import React from 'react';
import { Dialog as MuiDialog, DialogContent } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import useStyles from './index.style';

const Dialog = withStyles((theme) => ({
  paper: {
    margin: 20,
    [theme.breakpoints.up('sm')]: {
      margin: 40,
      maxWidth: 695,
    },
  },
}))(MuiDialog);

export default (props) => {
  const defaultProps = { ...props, closeAfterTransition: true };
  const { closeModal, open, children } = props;

  const css = useStyles();

  return (
    <Dialog onClose={closeModal} open={open} scroll="paper" {...defaultProps} maxWidth="md">
      <DialogContent dividers={false} className={css.MuiDialogContentRoot}>
        {children}
      </DialogContent>
    </Dialog>
  );
};
